import React from "react";
import ReactDOM from "react-dom";
import { WithTranslation, withTranslation } from "react-i18next";

import { IconButton } from "../button";
import HiddenFileInput from "../fileUploader/HiddenFileInput";
import { getIcon, UploadIcon } from "../icon";

interface IProps {
    onFileChange: (files: File[]) => void;
    title?: string;
    iconName?: string;
    width?: string;
    hotspotId?: string;
    accept?: string;
    preventHover?: boolean;
    multiple?: boolean;
    isDisabled?: boolean;
    isDecorative?: boolean;
    isTransparent?: boolean;
    testIdOfHiddenInput?: string;
    name?: string;
    renderCustomButton?: (onClick: () => void, isDisabled: boolean) => void;
}

// provides functionality for opening of the html file input via custom button
class FileUploadButton extends React.PureComponent<IProps & WithTranslation> {

    _fileInput = React.createRef<HTMLInputElement>();

    handleUploadButtonClick = () => {
        this._fileInput.current.click();
    };

    handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.props.onFileChange?.(Array.from(event.target.files));
    };

    render() {
        const Icon = this.props.iconName ? getIcon(this.props.iconName) : UploadIcon;
        return (
            <>
                {!this.props.renderCustomButton &&
                    <IconButton title={this.props.title ?? this.props.t("Components:FileUploader.ChooseFile")}
                                hotspotId={this.props.hotspotId}
                                onClick={this.handleUploadButtonClick}
                                isDisabled={this.props.isDisabled}
                                isDecorative={this.props.isDecorative}
                                isTransparent={this.props.isTransparent}>
                        <Icon width={this.props.width} preventHover={this.props.preventHover}/>
                    </IconButton>
                }
                {this.props.renderCustomButton?.(this.handleUploadButtonClick, this.props.isDisabled)}
                {/*we need file input to programmatically trigger the "open file" window*/}
                {ReactDOM.createPortal(
                    <HiddenFileInput passRef={this._fileInput}
                                     accept={this.props.accept}
                                     multiple={this.props.multiple}
                                     testId={this.props.testIdOfHiddenInput}
                                     name={this.props.name}
                                     onChange={this.handleFileInputChange}/>
                    , document.body)}
            </>
        );
    }
}

export default withTranslation(["Components"])(FileUploadButton);